// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__2e4e_","animate-preloader":"Preloader_animate-preloader__3o_mD"};